import { LiveBadge } from "@/components/myEntry/LiveBadge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { POLL_INTERVAL } from "@/constants";
import { useHandleError } from "@/hooks/useHandleError";
import { useWebUserRoundEntryUnits } from "@/hooks/useWebUserRoundEntryUnits";
import type { WebUserRoundEntryUnitWithResults } from "@/types/WebUserRoundEntryUnit";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LiveTab } from "./LiveTab";
import { PrizeDistributedTab } from "./PrizeDistributedTab";
import { ScheduledTab } from "./ScheduleTab";
import { TABS, type Tab } from "./constant";

export const MyEntry = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const initialTabType = searchParams.get("tab") || "live";
  const [selectedTab, setSelectedTab] = useState<Tab>(TABS.find((tab) => tab.type === initialTabType) || TABS[0]);

  const tabClassName =
    "w-1/3 h-full bg-white text-dark-gray rounded-none border border-none data-[state=active]:font-semibold data-[state=active]:text-white data-[state=active]:bg-primary data-[state=active]:shadow-none text-sm";

  const listError: { type: string; value: string }[] = [
    {
      type: "schedule",
      value: "ユーザーのラウンドエントリーユニットを取得できませんでした",
    },
    {
      type: "live",
      value: "ユーザーのラウンドエントリーユニットを取得できませんでした",
    },
    {
      type: "prizeDistributed",
      value: "ユーザーのラウンドエントリーユニットを取得できませんでした",
    },
  ];

  const handleError = useHandleError(listError.find((error) => error.type === selectedTab.type)?.value);

  const { data, isLoading } = useWebUserRoundEntryUnits<WebUserRoundEntryUnitWithResults>(
    selectedTab.type,
    handleError,
    "ja",
    selectedTab.type === "live" ? POLL_INTERVAL : undefined,
  );

  useEffect(() => {
    setSelectedTab(TABS.find((tab) => tab.type === initialTabType) || TABS[0]);
  }, [initialTabType]);

  return (
    <div className="w-full">
      <Tabs
        value={selectedTab.type.toString()}
        onValueChange={(value) => {
          navigate(`/my-entry?tab=${value}`);
        }}
      >
        <TabsList className="w-full p-0 rounded-none h-14">
          <TabsTrigger className={tabClassName} value={TABS[0].type}>
            {TABS[0].title}
          </TabsTrigger>
          <TabsTrigger className={tabClassName} value={TABS[1].type}>
            <div className="flex items-center gap-2">
              <LiveBadge
                isInTab={true}
                isSelectedTab={selectedTab.type === "live"}
                isInMenu={false}
                text="LIVE"
                className="items-center justify-center"
                iconClassName=""
                textClassName="font-semibold text-[12px]"
              />
              <span>{TABS[1].title}</span>
            </div>
          </TabsTrigger>
          <TabsTrigger className={tabClassName} value={TABS[2].type}>
            {TABS[2].title}
          </TabsTrigger>
        </TabsList>

        <TabsContent value={TABS[0].type}>
          <ScheduledTab userRoundEntryUnits={data.userRoundEntryUnits} isLoading={isLoading} />
        </TabsContent>

        <TabsContent value={TABS[1].type}>
          <LiveTab type={selectedTab.type} userRoundEntryUnits={data.userRoundEntryUnits} isLoading={isLoading} />
        </TabsContent>

        <TabsContent value={TABS[2].type}>
          <PrizeDistributedTab userRoundEntryUnits={data.userRoundEntryUnits} isLoading={isLoading} />
        </TabsContent>
      </Tabs>
    </div>
  );
};
